import { Fragment, FunctionalComponent, VNode, h } from 'preact';
import { Link, List, ListItem, Section } from '../List';
import { TCFVendor, TcfLabels } from '@usercentrics/cmp-browser-sdk';
import { PaddedTitle } from './VendorDescription.styles';
import StorageInfo from '../StorageInfo';
import { memo } from 'preact/compat';

type Props = {
  onToggleExpandable: () => void;
  vendor: TCFVendor;
  labels: TcfLabels;
};

const VendorDescription: FunctionalComponent<Props> = memo(({ vendor, labels, onToggleExpandable }) => {
  const { cookieInformation: cookieInformationLabels, vendor: vendorLabels } = labels;
  const mapList = (title: string, list: { id: number; name: string }[]): VNode | null => {
    if (!list.length) {
      return null;
    }

    return (
      <Section>
        <PaddedTitle>{title}</PaddedTitle>
        <List>
          {list.map((item) => {
            return <ListItem showBulletPoints>{item.name}</ListItem>;
          })}
        </List>
      </Section>
    );
  };

  return (
    <Fragment>
      {mapList(vendorLabels.purposes, vendor.purposes)}
      {mapList(vendorLabels.legitimateInterest, vendor.legitimateInterestPurposes)}
      {mapList(vendorLabels.specialPurposes, vendor.specialPurposes)}
      {mapList(vendorLabels.features, vendor.features)}
      {mapList(vendorLabels.specialFeatures, vendor.specialFeatures)}
      {vendor.policyUrl && (
        <Section>
          <PaddedTitle>{vendorLabels.privacyPolicy}</PaddedTitle>
          <Link href={vendor.policyUrl}>{vendor.policyUrl}</Link>
        </Section>
      )}
      <StorageInfo
        cookieInformationLabels={cookieInformationLabels}
        cookieMaxAgeSeconds={vendor.cookieMaxAgeSeconds}
        cookieRefresh={vendor.cookieRefresh}
        deviceStorage={vendor.deviceStorage}
        deviceStorageDisclosureUrl={vendor.deviceStorageDisclosureUrl}
        storageInfoAnchorLabel={`${vendor.name} ${labels.ariaLabels.vendorDetailedStorageInformation}`}
        onToggleExpandable={onToggleExpandable}
        usesCookies={vendor.usesCookies}
        usesNonCookieAccess={vendor.usesNonCookieAccess}
        isNonIabVendor={false}
      />
    </Fragment>
  );
});

export default VendorDescription;
